import React from 'react';
import { styled } from '@linaria/react';
import { useFooter } from 'contexts/FooterContext.jsx';

const Container = styled.div`
  position: relative;
  width: 100%;
`;

const Footer = (props) => {
  const { content } = useFooter();

  if (!content) return null;

  return (
    <Container {...props}>
      {content}
    </Container>
  );
};

export default Footer;
